export default "__VITE_ASSET__DPKKhdPS__"